/* eslint-disable no-console */
import React from 'react';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const CustomSwitch = (props) =>
{
	const { toggleEnabled, handleToggleChange, from, disabledCheck, disabled, name = '' } = props;

	const MaterialUISwitch = styled(Switch)(({ theme }) => ({
		'& .MuiSwitch-switchBase' : {
			transform       : 'translateX(2px)',
			'&.Mui-checked' : {
				color                       : 'var(--whiteColor)',
				transform                   : 'translateX(22px)',
				'& .MuiSwitch-thumb:before' : {
					backgroundImage : "url('/images/icons/check.svg')",
					width           : 'var(--pixel10)',
					height          : 'var(--pixel10)',
					objectFit       : 'contain',
					content         : "''",
					position        : 'absolute',
					left            : 4,
					top             : 4,
					backgroundSize  : 'contain'
				},
				'& + .MuiSwitch-track' : {
					opacity : 1
				}
			}
		},
		'& .MuiSwitch-thumb' : {
			width       : 20,
			height      : 20,
			position    : 'relative',
			border      : '1px solid var(--primaryColor)',
			'&::before' : {
				content            : "''",
				position           : 'absolute',
				left               : 5,
				top                : 5,
				backgroundRepeat   : 'no-repeat',
				backgroundPosition : 'center',
				backgroundImage    : "url('/images/icons/cross.svg')",
				width              : 'var(--pixel8)',
				height             : 'var(--pixel8)',
				objectFit          : 'contain',
				backgroundSize     : 'contain'
			}
		},
		'& .MuiSwitch-track' : {
			opacity         : 1,
			backgroundColor : theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
			borderRadius    : 20 / 2
		}
	}));

	return (
		<MaterialUISwitch checked={toggleEnabled} disabled={disabled || (from === 'createContract' && disabledCheck)} name={name} onChange={handleToggleChange} />
	);
};

export default CustomSwitch;
